/**
 * `RpcError.code === "LOCKED_BY_OTHER_TAB"` için özel ekran.
 *
 * Aşama 0 ölçümü: `opfs-sahpool` VFS'i havuz dosyalarının her biri üzerinde
 * ÖZEL SyncAccessHandle tutar; ikinci sekme veritabanını açamaz ve
 * `createSyncAccessHandle` DOMException atar. Kilit sekme kapanınca serbest
 * kalıyor — kalıcı bozulma değil. Kullanıcının bunu anlaması gerekiyor, aksi
 * hâlde "uygulama bozuldu" sanır.
 */

import { Button, Notice } from "../ui/primitives";
import { M } from "../dil";

export interface LockedScreenProps {
  readonly onRetry: () => void;
  readonly retrying?: boolean;
}

export function LockedScreen({ onRetry, retrying = false }: LockedScreenProps) {
  return (
    <main className="mx-auto flex min-h-dvh max-w-xl flex-col justify-center p-6">
      <div className="pf-card p-5">
        <h1 className="text-[18px] font-semibold text-ink">{M.kabuk.baskaSekme.baslik}</h1>
        <p className="mt-3 text-[13px] leading-relaxed text-ink">
          {M.kabuk.baskaSekme.tekSekme}
        </p>
        <p className="mt-3 text-[13px] leading-relaxed text-muted">
          {M.kabuk.baskaSekme.guvende}
        </p>

        <div className="mt-4 flex flex-wrap gap-2">
          <Button variant="primary" onClick={onRetry} disabled={retrying}>
            {retrying ? M.kabuk.baskaSekme.deneniyor : M.kabuk.baskaSekme.yenidenDene}
          </Button>
          <Button onClick={() => globalThis.close?.()}>{M.kabuk.baskaSekme.sekmeyiKapat}</Button>
        </div>

        <div className="mt-5">
          <Notice tone="info" title={M.kabuk.baskaSekme.nedenBaslik}>
            <p>{M.kabuk.baskaSekme.neden}</p>
          </Notice>
        </div>
      </div>
    </main>
  );
}
